import styled from "@emotion/styled";
import {
  Button,
  Callout,
  FieldError,
  FlexRow,
  Form,
  H2,
  Input,
  Label,
  Link,
  Text,
} from "atoms";
import { ReactComponent as IconBrush } from "assets/images/hug-brush-6.svg";
import { useSubscribeWeeklyHugsForm } from "features/hub/api/useNewsLetter";
import { fieldOptions, validators } from "utils/form";

function Newsletter() {
  const {
    onSubmit,
    register,
    mutation: { isSuccess },
    formState: { errors },
  } = useSubscribeWeeklyHugsForm();

  return (
    <NewsletterWrapper id="newsletter">
      <H2>Get hugs in your&nbsp;inbox</H2>

      {isSuccess ? (
        <Text>Thank you for subscribing!</Text>
      ) : (
        <>
          <Form onSubmit={onSubmit}>
            <FlexRow gap="10px">
              <Label inline>
                <Text size="xs" font="display" textTransform="uppercase">
                  Email
                </Text>

                <Input
                  {...register("email", {
                    ...fieldOptions.required,
                    validate: validators.validEmail,
                  })}
                />
              </Label>

              <Button variant="primary" type="submit" arrow="r">
                Subscribe
              </Button>
            </FlexRow>

            {errors.email && <FieldError>{errors.email.message}</FieldError>}
          </Form>

          <PrivacyText size="xxxs">
            By providing your email address, you agree to our{" "}
            <Link to="/privacy-policy">Privacy Policy</Link>.
          </PrivacyText>
        </>
      )}

      <BrushTexture aria-hidden="true" />
    </NewsletterWrapper>
  );
}

// TODO: Add brush in BG
const NewsletterWrapper = styled(Callout)(({ theme }) => ({
  background: theme.colors.bg,
  boxShadow: theme.boxShadow.light,
  marginTop: "4rem",
  paddingLeft: "1rem",
  paddingRight: "1rem",
  position: "relative",
  form: {
    gap: 10,
    marginBottom: 10,
    position: "relative",
    zIndex: 2,
  },
  label: {
    backgroundColor: theme.colors.bg,
  },
  "@media (min-width: 760px)": {
    flexDirection: "row",
    paddingLeft: "3.2rem",
    paddingRight: "3.2rem",
    textAlign: "left",
  },
  h2: {
    marginBottom: 10,
  },
  p: {
    marginBottom: 0,
    marginTop: 0,
  },
  "&>img": {
    alignSelf: "flex-start",
    flex: "0 1 100px",
    height: "auto",
    margin: "-1.5rem auto",
    pointerEvents: "none",
    width: 130,
    "@media (min-width: 760px)": {
      display: "block",
      flexBasis: 160,
      margin: "auto -1.66rem",
    },
    [theme.breakpoints.desktop]: {
      flexBasis: 200,
      margin: "auto -2rem",
    },
  },
  "&>div": {
    flex: "1 0 75%",
  },
}));

const PrivacyText = styled(Text)({
  marginTop: ".5rem",
});

const BrushTexture = styled(IconBrush)({
  height: "auto",
  maxWidth: 450,
  opacity: 0.05,
  pointerEvents: "none",
  position: "absolute",
  right: 0,
  top: 0,
  width: "calc(325px + 15vmax)",
  zIndex: 1,
});

export { Newsletter };
